import { useDevices } from "@/store/devices";

export default function isPairedDevice(jid: string) {
  const devices = useDevices.getState().devices;

  const isPaired = jid in devices;
  if (!isPaired) log.warn("device is not paired", jid);
  return isPaired;
}
